import {
  Button,
  Descriptions,
  Drawer,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
// import {
//   NotificationInfo,
//   SubscriptionInfo,
//   UserInfo,
// } from "../../../../context";
import {
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
  PlusCircleOutlined,
  CheckOutlined,
  PlusOutlined,
  FileImageOutlined,
  TagOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { NotificationInfo, SubscriptionInfo, UserInfo } from "../../../context";
// import { NotificationInfo, SubscriptionInfo, UserInfo } from "../../../context";

const MerchantCheckoutPayLater = ({
  open,
  close,
  setLoading,
  getAllPayLater,
  selectedData,
  productList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const scroll = {};
  const [form] = Form.useForm();
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const [specProductInfo, setSpecProductInfo] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const [openConfirmDiag, setOpenConfirmDiag] = useState(false);
  const [totalCost, setTotalCost] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [inputtedPayment, setInputtedPayment] = useState(null);
  const [inputtedEcashPayment, setInputtedEcashPayment] = useState(null);
  const [dialogData, setDialogData] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [discountDialog, setDiscountDialog] = useState(false);
  const [ePaymentDialog, setEPaymentDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [addProductToOrder, setAddProductToOrder] = useState(false);
  const [count, setCount] = useState(1);
  const [visible, setVisible] = useState(false);
  const scaleStep = 0.5;
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [selectedDiscountCat, setSelectedDiscountCat] = useState("");
  const [productDiscount, setProductDiscount] = useState({
    data: [],
    ready: false,
  });
  const [removeSetDiscountDialog, setRemoveSetDiscountDialog] = useState(false);

  const tableProps = {
    bordered: false,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      // dataIndex: "product",
      render: (text) => (
        <p>
          {text.product}
          {parseInt(text.is_per_piece) === 0 && ` - ${text.quantity}gram(s)`}
        </p>
      ),
      // <p>{text}</p>
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "Price x Quantity",
      align: "right",
      render: (text) => (
        <>
          {parseInt(text.is_per_piece) === 1 ? (
            <p style={{ minWidth: 80, textAlign: "right" }}>
              &#8369;{text.price} x {text.quantity}
            </p>
          ) : (
            <p style={{ minWidth: 80, textAlign: "right" }}>
              &#8369;{text.price}
            </p>
          )}
        </>
        // <p>
        //   &#8369;{text.price} x {text.quantity}
        // </p>
      ),
    },
    // {
    //   title: "Available",
    //   align: "right",
    //   render: (text) => <p>{text.customerorderroductinfo.quantity}</p>,
    // },
    {
      title: "Amount",
      align: "right",
      render: (text) => (
        <>
          {parseInt(text.is_per_piece) === 1 ? (
            <p>
              &#8369;{" "}
              {parseFloat(
                parseFloat(text.price) * parseFloat(text.quantity)
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          ) : (
            <p>
              &#8369;{" "}
              {parseFloat(parseFloat(text.price) * 1).toLocaleString(
                undefined,
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }
              )}
            </p>
          )}
        </>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p
          style={{
            width: 40,
            display: text.payment_method === "ecash" ? "none" : "block",
          }}
        >
          {/* <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setCount(parseInt(text.quantity));
                setEditDialog(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 5 }}
              size="small"
            />
          </Tooltip> */}

          {/* <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setDialogData(text);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
              style={{ marginRight: 5 }}
              size="small"
            />
          </Tooltip> */}
          {parseInt(text.customerorderroductinfo.allow_discount) === 1 && (
            <>
              {text.discount_category !== null ? (
                <Tooltip title="Remove Discount">
                  <Button
                    type="dashed"
                    shape="circle"
                    onClick={() => {
                      setDialogData(text);
                      setRemoveSetDiscountDialog(true);
                    }}
                    icon={<CloseCircleOutlined />}
                    size="small"
                  />
                </Tooltip>
              ) : (
                <Tooltip title="Discount">
                  <Button
                    type="dashed"
                    shape="circle"
                    onClick={() => {
                      setDialogData(text);
                      setDiscountDialog(true);
                    }}
                    icon={<TagOutlined />}
                    size="small"
                  />
                </Tooltip>
              )}
            </>
          )}
          {text.customerordervariantinfo !== null &&
            parseInt(text.customerordervariantinfo.allow_discount) === 1 && (
              <>
                {text.discount_category !== null ? (
                  <Tooltip title="Remove Discount">
                    <Button
                      type="dashed"
                      shape="circle"
                      onClick={() => {
                        setDialogData(text);
                        setRemoveSetDiscountDialog(true);
                      }}
                      icon={<CloseCircleOutlined />}
                      size="small"
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title="Discount">
                    <Button
                      type="dashed"
                      shape="circle"
                      onClick={() => {
                        setDialogData(text);
                        setDiscountDialog(true);
                      }}
                      icon={<TagOutlined />}
                      size="small"
                    />
                  </Tooltip>
                )}
              </>
            )}
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));
  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      transaction_id: selectedData !== null ? selectedData.transaction_id : "",
      order_category: "products",
    };
    axios
      .get("user/merchant/spec-transaction-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        // console.log("DATA", data);
        setOrderDetailsList({ data, ready: true });
        setTotalCost(calculateTotal(data));
        setTotalDiscount(calculateDiscount(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id, selectedData]);

  const getProductDiscount = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/discount-list", { params })
      .then((response) => {
        const data = response.data;
        setProductDiscount({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      // total += parseFloat(data[i].quantity) * parseFloat(data[i].price);
      total +=
        parseInt(data[i].is_per_piece) === 1
          ? parseFloat(data[i].quantity) *
            parseFloat(data[i].price.replace(",", ""))
          : parseFloat(data[i].price.replace(",", ""));
    }
    return total;
  };

  const calculateDiscount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].discount_amount) * 1;
    }
    return total;
  };

  const handleFetchProduct = (prodID) => {
    var params = {
      id: prodID,
      user_id: userData.data.id,
    };
    setSpecProductInfo({ data: [], ready: false });
    axios
      .get("user/merchant/spec-product-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setSpecProductInfo({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleClearTransaction = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("merchant_uid", userData.data.merchant_uid);
    formdata.append("total_cost", parseFloat(totalCost - totalDiscount));
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append(
      "allow_inventory",
      subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    var error = [];
    var cashpayment = parseFloat(
      inputtedPayment !== null ? inputtedPayment : 0
    );
    var ecashpayment = parseFloat(
      inputtedEcashPayment !== null ? inputtedEcashPayment : 0
    );
    if (
      selectedMethod !== "pay-later" &&
      selectedMethod !== "confirm-only" &&
      parseFloat(cashpayment + ecashpayment) <
        parseFloat(totalCost - totalDiscount)
    ) {
      error = "error";
    }
    if (error.length > 0) {
      rerunNotif("error", "Payment input invalid.");
    } else {
      setLoadings(true);
      setLoading(true);
      axios
        .post("user/merchant/confirm-payment", formdata)
        .then((response) => {
          const data = response.data;
          if (data === "success") {
            rerunNotif("success", "Confirm payment successfully.");
            setTimeout(() => {
              close();
              setLoadings(false);
              setLoading(false);
              getAllPayLater();
            }, 1000);
          }
        })
        .catch((error) => {
          setLoadings(false);
        });
    }
  };

  useEffect(() => {
    getMerchantInvoiceDetails();
    getProductDiscount();
  }, [getMerchantInvoiceDetails, getProductDiscount]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteProductInOrder();
    }, 2000);
  };

  const handleEPaymentOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setEPaymentDialog(false);
      setConfirmLoading(false);
      handleConfirmEPaymentAsPaid();
    }, 2000);
  };

  const handleRemoveSetDiscountOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setRemoveSetDiscountDialog(false);
      setConfirmLoading(false);
      handleConfirmRemoveSetDiscount();
    }, 2000);
  };

  const handleDeleteProductInOrder = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", dialogData !== null ? dialogData.id : "");
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    setLoadings(true);
    axios
      .post("user/merchant/delete-product-in-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete product successfully.");
          setTimeout(() => {
            if (orderDetailsList.data.length === 1) {
              close();
              setLoadings(false);
              setLoading(false);
              getAllPayLater();
            } else {
              setLoadings(false);
              getMerchantInvoiceDetails();
            }
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleConfirmEPaymentAsPaid = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("merchant_uid", userData.data.merchant_uid);

    formdata.append("payment", totalCost - totalDiscount);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append(
      "allow_inventory",
      subscriptionDetails.data.subsmerchantfeat.enable_inventory_report
    );

    setLoadings(true);
    axios
      .post("user/merchant/confirm-epayment", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirm payment as paid successfully.");
          setTimeout(() => {
            close();
            setLoadings(false);
            setLoading(false);
            getAllPayLater();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleConfirmRemoveSetDiscount = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", dialogData !== null ? dialogData.id : "");

    setLoadings(true);
    axios
      .post("user/merchant/remove-set-discount", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Confirm remove setted discount successfully.");
          setTimeout(() => {
            setLoadings(false);
            setLoading(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleEditQtyProduct = () => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", dialogData !== null ? dialogData.id : "");
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append("quantity", count);
    setLoadings(true);
    axios
      .post("user/merchant/edit-product-in-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated product successfully.");
          setTimeout(() => {
            setEditDialog(false);
            setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        setLoadings(false);
      });
  };

  const handleAddProductToOrder = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "transaction_id",
      selectedData !== null ? selectedData.transaction_id : ""
    );
    formdata.append(
      "payment_method",
      orderDetailsList.ready && orderDetailsList.data[0].payment_method
    );
    formdata.append(
      "merchant_id",
      orderDetailsList.ready && orderDetailsList.data[0].merchant_id
    );
    formdata.append(
      "customer_name",
      orderDetailsList.ready && orderDetailsList.data[0].customer_name
    );
    formdata.append(
      "customer_age",
      orderDetailsList.ready && orderDetailsList.data[0].customer_age
    );
    formdata.append(
      "customer_gender",
      orderDetailsList.ready && orderDetailsList.data[0].customer_gender
    );
    formdata.append(
      "contact_no",
      orderDetailsList.ready && orderDetailsList.data[0].contact_no
    );
    formdata.append(
      "customer_address",
      orderDetailsList.ready && orderDetailsList.data[0].customer_address
    );
    formdata.append(
      "table_no",
      orderDetailsList.ready && orderDetailsList.data[0].table_no
    );
    formdata.append(
      "product",
      specProductInfo.ready && specProductInfo.data.product
    );
    formdata.append(
      "description",
      specProductInfo.ready && specProductInfo.data.description
    );
    formdata.append("price", specProductInfo.ready && specProductInfo.data.srp);
    formdata.append(
      "service_category",
      orderDetailsList.ready && orderDetailsList.data[0].service_category
    );
    formdata.append(
      "status",
      orderDetailsList.ready && orderDetailsList.data[0].status
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/merchant/new-product-in-order", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "product-exist") {
          rerunNotif("error", "Product already added.");
          setTimeout(() => {
            setLoadings(false);
          }, 1000);
        }
        if (data === "success") {
          rerunNotif("success", "New product added successfully.");
          setTimeout(() => {
            setAddProductToOrder(false);
            setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const handleSetSpecDiscount = (values) => {
    const formdata = new FormData();

    var percentagedena = parseFloat(values.discount_percentage) / 100;
    var percentagevalue =
      parseFloat(dialogData !== null && dialogData.price) *
      parseFloat(percentagedena);

    var finaldisamount =
      selectedDiscountCat === "amount"
        ? parseFloat(values.discount_amount) *
          parseFloat(values.discount_quantity)
        : parseFloat(percentagevalue) * parseFloat(values.discount_quantity);

    formdata.append("user_id", userData.data.id);
    formdata.append("id", dialogData !== null && dialogData.id);
    formdata.append("finaldisamount", finaldisamount);
    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/merchant/set-spec-discount", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Spec discount added successfully.");
          setTimeout(() => {
            setDiscountDialog(false);
            setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Order Details"
      width={window.innerWidth > 800 ? 800 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ flexGrow: 1 }} />
          {/* <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setAddProductToOrder(true)}
            style={{
              display:
                orderDetailsList.ready &&
                orderDetailsList.data[0].payment_method === "ecash"
                  ? "none"
                  : "block",
            }}
          >
            Product
          </Button> */}

          <Button
            type="primary"
            icon={<FileImageOutlined />}
            onClick={() => setVisible(true)}
            style={{
              display:
                orderDetailsList.ready &&
                orderDetailsList.data[0].payment_method === "ecash"
                  ? "block"
                  : "none",
            }}
          >
            View Attachment
          </Button>
        </div>
      }
    >
      {selectedData !== null && (
        <>
          {orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash" && (
              <div>
                <Image
                  width={200}
                  style={{
                    display: "none",
                  }}
                  src=""
                  preview={{
                    visible,
                    scaleStep,
                    src: `${import.meta.env.VITE_API_IMAGE}payment/${
                      orderDetailsList.data[0].payment_attachment
                    }`,
                    onVisibleChange: (value) => {
                      setVisible(value);
                    },
                  }}
                  alt="payment-img"
                />
              </div>
            )}

          <div style={{ overflowX: "auto" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography style={{ fontSize: 14 }}>
                Customer Name:{" "}
                <span
                  style={{ fontWeight: "bold", textTransform: "capitalize" }}
                >
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].customer_name}
                </span>
              </Typography>

              <Typography
                style={{
                  fontSize: 14,
                  display:
                    orderDetailsList.ready &&
                    orderDetailsList.data[0].table_no !== "Table #"
                      ? "block"
                      : "none",
                }}
              >
                Location:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready && orderDetailsList.data[0].table_no}
                </span>
              </Typography>

              <Typography
                style={{
                  fontSize: 14,
                  display:
                    orderDetailsList.ready &&
                    orderDetailsList.data[0].contact_no !== null
                      ? "block"
                      : "none",
                }}
              >
                Customer #:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].contact_no}
                </span>
              </Typography>

              <Typography
                style={{
                  fontSize: 14,
                  display:
                    orderDetailsList.ready &&
                    orderDetailsList.data[0].customer_address !== null
                      ? "block"
                      : "none",
                }}
              >
                Customer Address:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].customer_address}
                </span>
              </Typography>

              <Typography
                style={{
                  fontSize: 14,
                  textTransform: "capitalize",
                }}
              >
                Status:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].service_category}
                </span>
              </Typography>
              <Typography
                style={{
                  fontSize: 14,
                  textTransform: "capitalize",
                  marginBottom: 10,
                }}
              >
                Transaction #:{" "}
                <span style={{ fontWeight: "bold" }}>
                  {orderDetailsList.ready &&
                    orderDetailsList.data[0].transaction_id}
                </span>
              </Typography>
            </div>

            <Table
              {...tableProps}
              pagination={false}
              columns={tableColumns}
              dataSource={
                orderDetailsList.data.length > 0 ? orderDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.id}
              expandable={{
                expandedRowRender: (record) => (
                  <p style={{ margin: 0 }}>
                    Discount by{" "}
                    {record.discount_category === "percentage"
                      ? `(${record.price} * ${record.discount_percentage}%) * ${record.discount_quantity} = ${record.discount_amount}`
                      : `${record.discount_amount}`}
                  </p>
                ),
                rowExpandable: (record) => record.discount_category !== null,
              }}
            />
            <div style={{ display: "flex", padding: 15 }}>
              <div style={{ flexGrow: 1 }} />
              <div>
                <Typography
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    textAlign: "right",
                  }}
                >
                  Total: &#8369;
                  {totalCost.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
                {totalDiscount > 0 && (
                  <>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: 16,
                        textAlign: "right",
                      }}
                    >
                      Discount: &#8369;
                      {totalDiscount.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        fontSize: 16,
                        textAlign: "right",
                      }}
                    >
                      Grand Total: &#8369;
                      {parseFloat(totalCost - totalDiscount).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}
                    </Typography>
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      <Button
        type="primary"
        loading={loadings}
        style={{ width: "100%", borderRadius: "20px" }}
        onClick={() => {
          if (
            orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash"
          ) {
            setEPaymentDialog(true);
          } else {
            setOpenConfirmDiag(true);
          }
        }}
      >
        {!loadings
          ? orderDetailsList.ready &&
            orderDetailsList.data[0].payment_method === "ecash"
            ? "Confirm Payment"
            : "Checkout"
          : "Loading"}
      </Button>

      <Modal
        title=""
        open={openConfirmDiag}
        onCancel={() => setOpenConfirmDiag(false)}
        footer={null}
        centered
      >
        <Form
          layout="vertical"
          name="merchant-payment-confirm3"
          initialValues={{ total_cost: totalCost - totalDiscount }}
          onFinish={handleClearTransaction}
          autoComplete="off"
          form={form}
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <div
              style={{
                marginTop: 20,
                marginBottom: 5,
              }}
            >
              <Typography>Total Cost</Typography>
            </div>

            <div
              style={{
                border: "1px solid #e5e5e5",

                marginBottom: 20,
                padding: 10,
                borderRadius: 10,
              }}
            >
              {parseFloat(totalCost - totalDiscount).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </div>

            <Form.Item
              name="method"
              label="Method"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select method"
                onChange={(e) => {
                  setSelectedMethod(e);
                  setInputtedPayment(null);
                  setInputtedEcashPayment(null);
                  form.setFieldsValue({
                    customer_payment: null,
                    customer_epayment: null,
                    e_ref_no: null,
                  });
                }}
                size="large"
                showSearch
              >
                <Select.Option value={"confirm-only"}>
                  Confirm Only
                </Select.Option>
                <Select.Option value={"enter-payment"}>
                  Confirm w/ Cash Payment
                </Select.Option>
                {/* NEW FUNCTION`` */}
                <Select.Option value={"ecash-payment"}>
                  Confirm w/ ECash Payment
                </Select.Option>
                <Select.Option value={"split-payment"}>
                  Split Payment
                </Select.Option>
                {/* <Select.Option value={"pay-later"}>Pay Later</Select.Option> */}
              </Select>
            </Form.Item>

            {selectedMethod === "enter-payment" && (
              <Form.Item
                name="customer_payment"
                label="Cash Payment"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={999999999999}
                  initialvalues={0}
                  size="large"
                  style={{ width: "100%" }}
                  step="0.01"
                  onChange={(value) => {
                    setInputtedPayment(value);
                  }}
                />
              </Form.Item>
            )}

            {selectedMethod === "ecash-payment" && (
              <>
                <Form.Item
                  name="customer_epayment"
                  label="ECash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedEcashPayment(value)}
                  />
                </Form.Item>
                <Form.Item
                  name="e_ref_no"
                  label="Reference #"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Input placeholder="Set ref no" size="large" />
                </Form.Item>
              </>
            )}

            {selectedMethod === "split-payment" && (
              <>
                <Form.Item
                  name="customer_payment"
                  label="Cash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedPayment(value)}
                  />
                </Form.Item>
                <Form.Item
                  name="customer_epayment"
                  label="ECash Payment"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={1}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="0.01"
                    onChange={(value) => setInputtedEcashPayment(value)}
                  />
                </Form.Item>
                <Form.Item
                  name="e_ref_no"
                  label="Reference #"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <Input placeholder="Set ref no" size="large" />
                </Form.Item>
              </>
            )}

            {selectedMethod === "enter-payment" ? (
              <>
                {inputtedPayment !== null && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      border: "1px solid green",
                    }}
                  >
                    <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
                      &#8369;
                      {parseFloat(
                        parseFloat(inputtedPayment) -
                          parseFloat(totalCost - totalDiscount)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                    <Typography style={{ color: "green", fontWeight: "bold" }}>
                      Change
                    </Typography>
                  </div>
                )}
              </>
            ) : null}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Confirm"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Are you sure to delete this product?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />

      <Modal
        title=""
        open={editDialog}
        onCancel={() => setEditDialog(false)}
        footer={null}
        width={350}
        centered
      >
        {dialogData !== null && (
          <>
            <Descriptions column={1} style={{ marginTop: 20 }}>
              <Descriptions column={1}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Image
                    width={"auto"}
                    height={150}
                    src={
                      dialogData.product_image !== null
                        ? `${import.meta.env.VITE_API_IMAGE}products/${
                            dialogData.customerorderroductinfo.product_image
                          }`
                        : Img
                    }
                    placeholder={"logo"}
                    preview={
                      dialogData.customerorderroductinfo.product_image !== null
                        ? true
                        : false
                    }
                    alt="product-img"
                  />
                </div>
              </Descriptions>
              <Descriptions.Item
                label="Product"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                {dialogData.product}
              </Descriptions.Item>
              <Descriptions.Item
                label="Description"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                {dialogData.description}
              </Descriptions.Item>
              <Descriptions.Item
                label="Price"
                contentStyle={{
                  fontWeight: "bold",
                }}
              >
                &#8369;{dialogData.price}
              </Descriptions.Item>
            </Descriptions>
            <div
              style={{
                border: "1px solid #e5e5e5",
                marginTop: 10,
                marginBottom: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setCount(count - 1);
                  }}
                  icon={<MinusCircleOutlined />}
                  disabled={count === 1 ? true : false}
                />
                <Typography.Title
                  level={4}
                  style={{ marginLeft: 10, marginRight: 10, marginTop: 10 }}
                >
                  {count}
                </Typography.Title>
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setCount(count + 1);
                  }}
                  icon={<PlusCircleOutlined />}
                />
              </div>
            </div>

            <div>
              <Button
                type="primary"
                onClick={handleEditQtyProduct}
                icon={<CheckOutlined />}
                style={{ width: "100%" }}
              >
                Update
              </Button>
            </div>
          </>
        )}
      </Modal>

      <Modal
        title=""
        open={discountDialog}
        onCancel={() => setDiscountDialog(false)}
        footer={null}
        centered
      >
        <Form
          layout="vertical"
          name="add-discount-spec-order3"
          initialValues={{ total_cost: totalCost - totalDiscount }}
          onFinish={handleSetSpecDiscount}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="discount_category"
              label="Discount Category"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="-"
                onChange={(e) => {
                  setSelectedDiscountCat(e);
                }}
                size="large"
                showSearch
              >
                <Select.Option value={"amount"}>Amount</Select.Option>
                <Select.Option value={"percentage"}>Percentage</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="discount_quantity"
              label="Discount Quantity"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={dialogData !== null && dialogData.quantity}
                initialvalues={1}
                size="large"
                style={{ width: "100%" }}
                step="1"
              />
            </Form.Item>

            {selectedDiscountCat === "amount" && dialogData !== null && (
              <Form.Item
                name="discount_amount"
                label="Discount Amount"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <InputNumber
                  min={1}
                  max={
                    parseFloat(dialogData.price) *
                    parseFloat(dialogData.quantity)
                  }
                  initialvalues={0}
                  size="large"
                  style={{ width: "100%" }}
                  step="0.01"
                />
              </Form.Item>
            )}

            {selectedDiscountCat === "percentage" && productDiscount.ready && (
              <Form.Item
                name="discount_percentage"
                label="Discount Percentage"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Select placeholder="-" size="large" showSearch>
                  {productDiscount.data.length > 0 &&
                    productDiscount.data.map((data, index) => (
                      <Select.Option value={data.percentage} key={index}>
                        {data.description} - {data.percentage}%
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Set Discount"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title=""
        open={addProductToOrder}
        onCancel={() => setAddProductToOrder(false)}
        footer={null}
        centered
      >
        <Form
          layout="vertical"
          name="add-customer-order3"
          initialValues={{ remember: false }}
          onFinish={handleAddProductToOrder}
          autoComplete="off"
        >
          <Typography
            style={{ fontSize: 18, marginBottom: 20, fontWeight: "bold" }}
          >
            Add Product
          </Typography>
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="product_id"
              label="Product"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select product"
                onChange={(e) => {
                  handleFetchProduct(e);
                }}
                size="large"
                showSearch
              >
                {productList.data.length > 0 ? (
                  productList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.product}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No product found!</Select.Option>
                )}
              </Select>
            </Form.Item>

            <Form.Item
              name="quantity"
              label="Quantity"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={1}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="1"
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Add"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Are you sure to confirm this transaction as paid?"
        open={ePaymentDialog}
        onOk={handleEPaymentOk}
        confirmLoading={confirmLoading}
        onCancel={() => setEPaymentDialog(false)}
        centered
      />

      <Modal
        title="Are you sure to remove the setted discount?"
        open={removeSetDiscountDialog}
        onOk={handleRemoveSetDiscountOk}
        confirmLoading={confirmLoading}
        onCancel={() => setRemoveSetDiscountDialog(false)}
        centered
      />
    </Drawer>
  );
};

export default MerchantCheckoutPayLater;
